import React from 'react'
import { Helmet } from 'react-helmet-async'

const Meta = () => {
  return (
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="manifest" href="/manifest.json" />
      <link rel="shortcut icon" href="/favicon.ico" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="Securitas ADA" />
      <meta name="msapplication-TileColor" content="#8d5fff" />
      <meta name="theme-color" content="#E7313A" />
      <title>Securitas ADA</title>
      <meta name="description" content="Securitas ADA" />
      <script>
        {'if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js")'}
      </script>
    </Helmet>
  )
}

export default Meta
